import { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";
import AuthPage from "./components/AuthPage";
import Dashboard from "./components/Dashboard";
import AdminDashboard from "./components/AdminDashboard";
import ResetPassword from "./components/ResetPassword";
import PosterSharePage from "./components/PosterSharePage";

const POSTER_ROUTE = window.location.pathname.match(/^\/p\/(rec[A-Za-z0-9]{14})\/(att[A-Za-z0-9]{14})\/?$/);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function App() {
  const [token, setToken] = useState(() => localStorage.getItem("ldc_token") || null);
  const [me, setMe] = useState(null);
  const [view, setView] = useState("auto"); // auto | admin | artist
  const [resetToken, setResetToken] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("reset_token");
  });

  useEffect(() => {
    if (!token) { setMe(null); return; }
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setMe(res.data))
      .catch((err) => {
        if (err.response?.status === 401) handleLogout();
        else setMe({ is_admin: false, record_count: 1 });
      });
  }, [token]);

  const clearResetToken = () => {
    window.history.replaceState({}, document.title, window.location.pathname);
    setResetToken(null);
  };

  const handleLogin = (newToken) => {
    setView("auto");
    setToken(newToken);
  };

  const handleLogout = () => {
    localStorage.removeItem("ldc_token");
    localStorage.removeItem("ldc_email");
    setToken(null);
    setMe(null);
    setView("auto");
  };

  if (POSTER_ROUTE) {
    return <div className="App"><PosterSharePage recordId={POSTER_ROUTE[1]} attachmentId={POSTER_ROUTE[2]} /></div>;
  }

  if (resetToken) {
    return (
      <div className="App">
        <ResetPassword token={resetToken} onDone={clearResetToken} />
      </div>
    );
  }

  if (!token) {
    return <div className="App"><AuthPage onLogin={handleLogin} /></div>;
  }

  if (!me) {
    return <div className="App"><div className="loading-screen" /></div>;
  }

  const showAdmin = me.is_admin && (view === "admin" || (view === "auto"));

  return (
    <div className="App">
      {showAdmin ? (
        <AdminDashboard
          token={token}
          onLogout={handleLogout}
          hasOwnProfile={me.record_count > 0}
          onMyProfile={() => setView("artist")}
        />
      ) : (
        <Dashboard
          token={token}
          onLogout={handleLogout}
          isAdmin={me.is_admin}
          onAdmin={() => setView("admin")}
        />
      )}
    </div>
  );
}

export default App;
